import ContentLoader from '@rio-cloud/rio-uikit/ContentLoader';

import { ChartLoader } from '@/components/ui/ChartLoader';

export const EnergyChartSkeleton = () => {
    const totalCardSkeleton = (
        <div className='display-flex width-100pct flex-column align-items-center gap-10 padding-25'>
            <ContentLoader height={20} width={150} />
            <ContentLoader height={40} width={200} />
        </div>
    );
    return (
        <>
            <div className='display-flex'>
                {totalCardSkeleton}
                <div className='margin-y-25 border-width-1' />
                {totalCardSkeleton}
            </div>
            <div
                className='width-100pct margin-top-50 padding-right-20'
                style={{ marginBottom: '40px', paddingLeft: '70px' }}
            >
                <ChartLoader hasYaxis />
            </div>
            <div className='display-flex justify-content-end padding-x-20 padding-bottom-20'>
                <ContentLoader height={20} width={150} />
            </div>
        </>
    );
};
